"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var tile_styled_component_1 = require("./tile.styled.component");
var Tile = function (_a) {
    var className = _a.className, fullHeight = _a.fullHeight, header = _a.header, icon = _a.icon, children = _a.children, alternateSlot = _a.alternateSlot, _b = _a.draggable, draggable = _b === void 0 ? false : _b, _c = _a.hideDraggableHandle, hideDraggableHandle = _c === void 0 ? false : _c, noMarginContent = _a.noMarginContent;
    return (react_1.default.createElement(tile_styled_component_1.TileContainer, { className: className, fullHeight: fullHeight },
        react_1.default.createElement(tile_styled_component_1.TileHeaderContainer, null,
            icon && react_1.default.createElement(tile_styled_component_1.TileIcon, null, icon),
            header && react_1.default.createElement(tile_styled_component_1.TileHeader, null, header),
            react_1.default.createElement(tile_styled_component_1.TileAlternateSlot, null,
                alternateSlot,
                draggable && !hideDraggableHandle && (react_1.default.createElement(tile_styled_component_1.Draggable, { className: "draggable-handle", "data-test-id": "overview_draggable_handle" })))),
        react_1.default.createElement(tile_styled_component_1.TileContent, { className: draggable && hideDraggableHandle ? 'draggable-handle' : '', noMarginContent: noMarginContent }, children)));
};
Tile.displayName = 'Tile';
exports.GridTile = function (props) { return react_1.default.createElement(Tile, __assign({}, props, { fullHeight: true })); };
exports.GridTile.displayName = 'GridTile';
exports.DraggableGridTile = function (props) {
    var _a;
    return (react_1.default.createElement(Tile, __assign({}, props, { fullHeight: true, draggable: (_a = props.draggable) !== null && _a !== void 0 ? _a : true })));
};
exports.DraggableGridTile.displayName = 'DraggableGridTile';
exports.default = Tile;
//# sourceMappingURL=tile.component.js.map